import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '~shared/shadcn/ui/card';
import { Input } from '~shared/shadcn/ui/input';
import { Label } from '~shared/shadcn/ui/label';

interface SubjectFieldProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

export function SubjectField({ value, onChange, error }: SubjectFieldProps) {
  return (
    <Card className="rounded-xl border border-[#E5E7EB] bg-white p-6 shadow-sm transition hover:shadow-md">
      <CardHeader className="p-0 pb-4">
        <CardTitle className="text-sm font-medium">Email Subject</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <div className="space-y-2">
          <Label htmlFor="email-subject" className="text-sm text-muted-foreground">
            Subject Line
          </Label>
          <Input
            id="email-subject"
            placeholder="Access Your New {studio_name} Parent Portal"
            value={value}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            className={error ? 'border-red-500' : ''}
            required
          />
          {error && <p className="text-sm text-red-500">{error}</p>}
          <p className="text-xs text-muted-foreground">
            Keep it clear and actionable. This appears in the recipient&apos;s inbox.
          </p>
        </div>
      </CardContent>
    </Card>
  );
}

